import React from "react";

const ProfilePicture = ({ name, sizePx, src,customStyle}) => {
  const hasWhiteSpace = (s) => {
    if (s) {
      return s.indexOf(" ");
    }
  };

  const getInitialsChars = (name) => {
    if (name) {
      if (hasWhiteSpace(name) > 0) {
        //If name and surname take first character of each
        let firstName = name.substring(0, hasWhiteSpace(name));
        let lastName = name.substring(hasWhiteSpace(name) + 1);
        return {
          nameFisrtChar: firstName.charAt(0).toUpperCase(),
          surnameFirstChar: lastName.charAt(0).toUpperCase(),
        };
      } else {
        //If just name take first and second characteres
        return {
          nameFisrtChar: name.charAt(0).toUpperCase(),
          surnameFirstChar: name.charAt(1).toUpperCase(),
        };
      }
    }
  };

  return (
    <React.Fragment>
      <div
        style={{
          width: sizePx ? sizePx : 36,
          height: sizePx ? sizePx : 36,
          fontSize: sizePx ? sizePx : 36,
        }}
      >
        {src &&
        (src.match(/\.(jpeg|jpg|gif|png)$/) || src.match(/(blob)/)) != null ? (
          <img
            className={`d-flex justify-content-center align-items-center w-100 h-100 rounded-circle header-profile-user ${customStyle}`}
            style={{
              padding: sizePx > 36 ? 3 : 0,
            }}
            src={src}
            alt="Header Avatar"
          />
        ) : (
          <span
            className={`d-flex justify-content-center align-items-center w-100 h-100 rounded-circle header-profile-user ${customStyle}`}
            style={{
              fontSize: "0.4em",
            }}
          >
            {name
              ? getInitialsChars(name).nameFisrtChar +
                "" +
                getInitialsChars(name).surnameFirstChar
              : null}
          </span>
        )}
      </div>
    </React.Fragment>
  );
};

export default ProfilePicture;
